const SAFE_FONT_BY_FAMILY: Record<string, string> = {
  'system-ui': 'system-ui, -apple-system, sans-serif',
  inter: 'system-ui, -apple-system, sans-serif',
  'dm sans': '"DM Sans", system-ui, sans-serif',
  roboto: '"Roboto", system-ui, sans-serif',
  'open sans': '"Open Sans", system-ui, sans-serif',
  montserrat: '"Montserrat", system-ui, sans-serif',
  poppins: '"Poppins", system-ui, sans-serif',
  lato: '"Lato", system-ui, sans-serif',
}

function normalizeFontToken(value: string): string {
  return value
    .trim()
    .replace(/^['"]|['"]$/g, '')
    .replace(/\s+/g, ' ')
    .toLowerCase()
}

export function canonicalBrandingFontStack(value: string): string {
  const raw = value.trim()
  if (!raw) return ''
  if (raw.length > 500 || /[<>{};]/.test(raw)) return ''

  const parts = raw.split(',').map(part => part.trim()).filter(Boolean)
  const family = normalizeFontToken(parts[0] || '')
  const canonical = SAFE_FONT_BY_FAMILY[family]
  if (!canonical) return ''

  const normalized = parts.map(normalizeFontToken)
  if (family === 'system-ui') {
    return normalized.length === 3
      && normalized[0] === 'system-ui'
      && normalized[1] === '-apple-system'
      && normalized[2] === 'sans-serif'
      ? canonical
      : ''
  }

  return normalized.length === 3
    && normalized[1] === 'system-ui'
    && normalized[2] === 'sans-serif'
    ? canonical
    : ''
}
